// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductHeading_title__f1msp","badge":"ProductHeading_badge__H9cPY","description":"ProductHeading_description__jNLH7"};